import React from 'react'
import { Box } from '@mui/material'
import { useReportSearchesModalData } from '@hooks'
import AppReportSearchesOfficesModalBlock from '@components/ReportSearchesModal/Content/OfficesBlock'
import AppReportSearchesSitesModalBlock from '@components/ReportSearchesModal/Content/SitesBlock'


export default function AppReportSearchesModalContent({ id_report, isRunning, isExtras }) {

	const { sitesData, officesData, areSummariesLoading } = useReportSearchesModalData(id_report, isRunning, isExtras)

	return <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: 1.5 }}>
		<AppReportSearchesSitesModalBlock isLoading={areSummariesLoading} sitesData={sitesData}/>
		<AppReportSearchesOfficesModalBlock isLoading={areSummariesLoading} officesData={officesData}/>
	</Box>
}